<template>
  <span v-if="$slots.default" :class="helperClasses">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    helperClasses: {
      type: [String, Array, Object],
      default: 'text-[1rem] text-[#373E49] leading-[1.5rem] mt-[4px] block',
    },
  },
};
</script>
